import { useMutation } from "@tanstack/react-query";
import estimateProvider from "@/providers/estimate.provider";

const VALIDATE_PDF_EXPORT_KEY = ["pdfExport", "validate"] as const;

export function useValidatePDFExportMutation() {
  return useMutation({
    mutationKey: VALIDATE_PDF_EXPORT_KEY,
    mutationFn: async (estimateId: string) => {
      const response = await estimateProvider.validatePDFExport(estimateId);
      if (!response.success) {
        throw new Error("Failed to validate PDF export");
      }
      return {
        pricing: response.data?.pricing ?? [],
        dimension: response.data?.dimension ?? [],
        requiresOfficeSelection: response.data?.requiresOfficeSelection ?? false,
      };
    },
  });
}
